{
  "AllSetTitle": "Alles is klaar",
  "AllSetSubtitle": "Er zijn op dit moment geen vragenlijsten beschikbaar.",
  "Back": "Terug",
  "Cancel": "Annuleren",
  "CompletedAtDate": "Voltooid op {{at}}",
  "ConsentDeclinedSubtitle": "U heeft besloten niet deel te nemen. Uw onderzoeksteam is beschikbaar als u vragen heeft.",
  "ConsentDeclinedTitle": "Toestemming geweigerd",
  "DevDataExport": "[DEV] Data Export",
  "DevDebug": "[DEV] Debug",
  "DevDemo": "[DEV] Demo",
  "EnrollmentClosedSubtitle": "De periode om deze stap af te ronden is verstreken. Uw onderzoeksteam is beschikbaar als u vragen heeft.",
  "EnrollmentClosedTitle": "Inschrijving gesloten",
  "EnrollmentCompleteSubtitle": "Uw toestemming is ondertekend. Er is hier op dit moment niets meer te doen — uw onderzoeksteam neemt contact met u op.",
  "EnrollmentCompleteSubtitlePrescreenOnly": "Er is hier op dit moment niets meer te doen — uw onderzoeksteam neemt contact met u op.",
  "EnrollmentCompleteTitle": "Alles is geregeld — toestemming ondertekend",
  "EnrollmentCompleteTitlePrescreenOnly": "Alles is geregeld",
  "EnrollmentEyebrowConsent": "Stap 2 van 2 · Geïnformeerde toestemming",
  "EnrollmentEyebrowConsentOnly": "Geïnformeerde toestemming",
  "EnrollmentEyebrowPrescreen": "Stap 1 van 2 · Pre-screening",
  "EnrollmentEyebrowPrescreenOnly": "Pre-screening",
  "EnrollmentFooter": "Deelname is vrijwillig. U kunt op elk moment stoppen.",
  "EnrollmentHeroBodyConsent": "Lees het toestemmingsformulier zorgvuldig door. U kunt uw onderzoeksteam alles vragen voordat u ondertekent, en u kunt zich op elk moment terugtrekken.",
  "EnrollmentHeroBodyPrescreen": "Beantwoord een paar korte vragen over uw gezondheid. Het duurt ongeveer 5 minuten en uw antwoorden blijven privé.",
  "EnrollmentHeroCtaConsent": "Toestemming lezen en ondertekenen",
  "EnrollmentHeroCtaConsentResume": "Ga verder met het toestemmingsformulier",
  "EnrollmentHeroCtaPrescreen": "Start pre-screening",
  "EnrollmentHeroCtaPrescreenResume": "Ga verder met pre-screening",
  "EnrollmentHeroTitleConsent": "U komt in aanmerking — bekijk uw toestemming",
  "EnrollmentHeroTitleConsentOnly": "Bekijk uw toestemming",
  "EnrollmentHeroTitlePrescreen": "Laten we kijken of dit onderzoek bij u past",
  "EnrollmentSectionLabel": "Uw inschrijving",
  "EnrollmentStepConsentBlurb": "Bekijk en onderteken uw toestemmingsformulier",
  "EnrollmentStepConsentName": "Geïnformeerde toestemming",
  "EnrollmentStepDone": "Klaar",
  "EnrollmentStepNext": "Volgende",
  "EnrollmentStepPrescreeningBlurb": "Een paar vragen om te controleren of dit onderzoek bij u past",
  "EnrollmentStepPrescreeningName": "Pre-screening",
  "ErrorUpdatingUser": "Fout bij het bijwerken van het gebruikersprofiel",
  "ExternalIdMissingSubtitle": "Open het onderzoek opnieuw vanaf de plek waar u zich hebt aangemeld.",
  "ExternalIdMissingTitle": "We konden dit onderzoek niet openen",
  "Failure": "Mislukking",
  "Done": "Klaar",
  "Finish": "Klaar",
  "FormProgress": "Voortgang formulier: {{progress}}%",
  "Home": "Thuis",
  "HomeSeeAllTasks": "Bekijk alle aankomende taken in Schema",
  "HomeTasksToday": "Taken voor vandaag, {{date}}",
  "Language": "Taal",
  "Leave": "Verlaten",
  "Loading": "Laden",
  "loadingScreenDoNotCloseMessage": "Dit kan even duren. Sluit deze pagina niet.",
  "LogOut": "Uitloggen",
  "LogoutConfirmationBody": "Weet je zeker dat je wilt uitloggen?",
  "LogoutConfirmationHeader": "Uitloggen",
  "More": "Meer",
  "MyStudies": "Mijn Studies",
  "Next": "Volgende",
  "NoSchedule": "Geen schema toegewezen",
  "NoScheduleDescription": "Je ziet hier je taken zodra er een schema aan je is toegewezen.",
  "NoScheduleForMonth": "Geen taken deze maand",
  "NoScheduleForMonthDescription": "Je hebt momenteel geen taken gepland voor deze maand. Je kunt de komende maanden bekijken voor eventuele aankomende taken.",
  "NoScheduleForWeek": "Geen taken deze week",
  "NoScheduleForWeekDescription": "Je hebt momenteel geen taken gepland voor deze week. Je kunt de komende weken bekijken voor eventuele aankomende taken.",
  "NotAnswered": "Niet beantwoord",
  "NoTasksForToday": "Je hebt geen taken voor vandaag.",
  "NotFoundSubtitle": "De pagina die u zoekt bestaat niet.",
  "NotImplementedYet": "Binnenkort beschikbaar...",
  "OfflineWarning": "Je bent offline. Controleer je internetverbinding.",
  "Previous": "Vorige",
  "Processing": "Verwerken",
  "QuestionnaireCompleteFailureMessage": "Het voltooien van de vragenlijst is mislukt. Probeer het opnieuw.",
  "questionnaireInitializationLoadingTitle": "Uw vragenlijst wordt voorbereid",
  "QuestionnaireRedirecting": "Doorverwijzen...",
  "QuestionnaireLeaveWarningMessage": "Uw voortgang is opgeslagen, maar de beoordeling is nog niet formeel ingediend. Als u nu vertrekt, moet u later verdergaan om deze te voltooien.",
  "QuestionnaireLeaveWarningTitle": "Nog niet klaar?",
  "PostQuestionnaireLeaveWarningMessage": "Uw vragenlijst is ingediend. U kunt de resterende informatie nu bekijken, of later terugkomen.",
  "PostQuestionnaireLeaveWarningTitle": "Bijna klaar!",
  "preScreeningBadge": "screening",
  "QuestionnaireNotAvailableNow": "Deze vragenlijst is nu niet beschikbaar",
  "QuestionnaireNotAvailableSubtitle": "Uw vragenlijst is afgerond of momenteel niet toegankelijk.",
  "PreScreeningCompleteTitle": "Screening voltooid",
  "PreScreeningCompleteSubtitle": "Bedankt — er is hier op dit moment niets meer te doen.",
  "QuestionnaireNotAvailableTitle": "Hier is niets te zien",
  "questionnaireSubmissionLoadingTitle": "Uw antwoorden worden opgeslagen",
  "QuestionnaireSummaryDescription": "Bedankt voor het invullen van deze vragenlijst. Controleer uw antwoorden en dien ze in wanneer u klaar bent.",
  "QuestionnaireUpdateFailureMessage": "Het bijwerken van de vragenlijst is mislukt. Probeer het opnieuw.",
  "QuestionnaireValidationErrorOnPreviousPage": "Sommige antwoorden op een vorige pagina zijn niet meer geldig. Corrigeer deze voordat u verdergaat.",
  "ProtocolEditor": "Protocol Editor",
  "ProtocolList": "Protocols",
  "Brands": "Brands",
  "Save": "Opslaan",
  "Schedule": "Schema",
  "ScheduleDayTasks_one": "{{count}} taak",
  "ScheduleDayTasks_other": "{{count}} taken",
  "SessionExpiryBody_one": "Voor je veiligheid word je over {{count}} seconde uitgelogd.",
  "SessionExpiryBody_other": "Voor je veiligheid word je over {{count}} seconden uitgelogd.",
  "SessionExpiryStay": "Ingelogd blijven",
  "SessionExpiryTitle": "Ben je er nog?",
  "ShellAccountButtonLabel": "Account",
  "ShellAccountDevSectionLabel": "Ontwikkelaar & beheer",
  "ShellDarkModeLabel": "Donkere modus",
  "ShellNavLabel": "Hoofdnavigatie",
  "SignedOutBody": "Voor je veiligheid word je na {{minutes}} minuten zonder activiteit uitgelogd. Antwoorden die je al hebt opgeslagen, blijven bewaard.",
  "SignedOutSignInAgain": "Opnieuw inloggen",
  "SignedOutTitle": "Je bent uitgelogd",
  "SkipToContent": "Ga naar inhoud",
  "Stay": "Blijven",
  "StudyInfo": "Studie-informatie",
  "studyParticipationBadge": "deelname",
  "Success": "Succes",
  "Surveys": "Vragenlijsten",
  "SystemInfo": "Systeeminformatie",
  "TaskRowAvailableNow": "Nu beschikbaar",
  "TaskRowDue": "Vervalt {{time}}",
  "TaskRowOpenUntil": "Open tot {{time}}",
  "TaskRowOpens": "Opent {{time}}",
  "TaskRowOpensUntil": "Opent\u00a0{{opens}}, tot\u00a0{{until}}",
  "Today": "Vandaag",
  "TranslationNotInManifest": "Vertaalbestand is niet gespecificeerd in het manifest ({{assetId}}, {{language}})",
  "UserUpdated": "Gebruikersprofiel bijgewerkt",
  "authError": {
    "connection": {
      "title": "Verbindingsfout",
      "message": "Kan geen verbinding maken met de authenticatieservice. Controleer uw internetverbinding en probeer het opnieuw."
    },
    "authService": {
      "title": "Authenticatie mislukt",
      "message": "Authenticatie mislukt. Probeer het opnieuw."
    },
    "unknown": {
      "title": "Onverwachte fout",
      "message": "Er is een onverwachte fout opgetreden tijdens de authenticatie. Probeer het opnieuw."
    },
    "tryAgain": "Probeer opnieuw"
  }
}
